// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Spacer,
  Text,
  Switch,
  Select,
  ButtonGroup,
  FormControl,
  FormLabel,
  IconButton,
  FormHelperText,
  Input,
  Link,
  Textarea,
  useColorMode,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Progress,
} from "@chakra-ui/react";
// Assets
import { BiSun, BiMoon, BiCategoryAlt } from "react-icons/bi";
import { Scrollbars } from 'react-custom-scrollbars';
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import IconBox from "components/Icons/IconBox";
import { HSeparator } from "components/Separator/Separator";
import MusicRow from "components/Tables/MusicRow";
import Upload from "components/FilesList/UploadFile";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
var moment = require('moment-jalaali')
import config from "config/index";
import { ExternalLinkIcon } from "@chakra-ui/icons";

import { RiStackLine, RiSlideshow4Line, RiPauseMiniLine, RiPlayFill, RiDeleteBin3Fill, RiLayoutTop2Fill, RiNewspaperFill, RiChat1Fill, RiMenuLine, RiArrowRightSLine } from "react-icons/ri";


import NiceButton from "components/NiceButton/NiceButton.js";
import allRoom from "api/room/all-room";
import editRoom from "api/room/edit-room";
import deleteRoom from "api/room/delete-room";
import { Flip, ToastContainer, toast } from 'react-toastify';
import allFiles from "api/filemanager/all-files";
import { useHistory, useLocation } from "react-router-dom";
import { getGlobal, setGlobal } from "config/global";
import MarkerRow from "components/Tables/MarkerRow";
import room from "variables/room";
import allChatroom from "api/chatroom/all-chatroom";
import allMenu from "api/menu/all-menu";
import addMarker from "api/room/add-marker";
import allTours from "api/tours/all-tours";
import allPopup from "api/popup/all-popup";
import deleteMarker from "api/room/delete-marker";
import editMarker from "api/room/edit-marker";
import { useDropzone } from 'react-dropzone';
import uploadFile from "api/filemanager/upload-file";
import createPopup from "api/popup/create-popup";
import { PopupGallery } from "components/PopupGallery/PopupGallery";
import { PopupList } from "components/PopupList/PopupList";

function RoomDetails() {
  const history = useHistory();

  // Chakra color mode
  const { id, address } = useParams()
  let icon = [
    { title: "مخفی", value: "transparent" },
    { title: "بالا", value: "up" },
    { title: "راست", value: "right" },
    { title: "پایین", value: "down" },
    { title: "چپ", value: "left" },
    { title: "نقطه", value: "point" },
    { title: "اطلاعات", value: "info" },
    { title: "لینک", value: "link" },
    { title: "افزودن", value: "add" },
    { title: "خرید", value: "buy" },
    { title: "خروج", value: "exit" },
    { title: "کامنت", value: "comment" },
    { title: "اشتراک گذاری", value: "share" },
    { title: "لیست", value: "list" },
    { title: "پلاس", value: "plus" },
    { title: "ایمیل", value: "email" },
    { title: "تلفن", value: "phone" },
    { title: "ادیت", value: "edit" },
    { title: "حذف", value: "delete" },
    { title: "فرم", value: "form" },
    { title: "متن", value: "text" },
    { title: "ویدیو", value: "video" },
    { title: "صدا", value: "sound" },
    { title: "پیوست", value: "attach" },
    { title: "مکان", value: "location" },
    { title: "تصویر", value: "image" },
    { title: "گالری", value: "gallery" },
  ]
  let color = [
    { title: "مشکی", value: "black" },
    { title: "سفید", value: "white" },
    { title: "سبز", value: "green" },
    { title: "قرمز", value: "red" },
    { title: "زرد", value: "yellow" },
    { title: "آبی", value: "blue" },
    { title: "قهوه ای", value: "brown" },
    { title: "لاجوردی", value: "azure" },
    { title: "سبز آبی", value: "teal" },
    { title: "طلایی", value: "gold" },
    { title: "نقره ای", value: "silver" },
    { title: "بنفش", value: "purple" },
    { title: "سرمه‌ای", value: "navyblue" },
    { title: "سبز نخودی", value: "palegreen" },
    { title: "خاکستری", value: "gray" },
    { title: "نارنجی", value: "orange" },
    { title: "عنابی", value: "maroon" },
    { title: "ذغالی", value: "charcoal" },
    { title: "یشمی", value: "aquamarine" },
    { title: "سرخابی", value: "fuchsia" },
    { title: "لیمویی", value: "lime" },
    { title: "ارغوانی", value: "magenta" },
    { title: "زیتونی", value: "olive" },
    { title: "فیروزه ای", value: "cyan" },

  ]

  const iconBlue = useColorModeValue("blue.500", "blue.500");
  const iconBgColor = useColorModeValue("gray.100", "navy.700");
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#dee2e6", "transparent");
  const { colorMode } = useColorMode();
  const [roomData, setRoomData] = useState({});
  const [title, setTitle] = useState("");
  const [sort, setSort] = useState(0);
  const [display, setDisplay] = useState(0);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isSaveMenuLoading, setIsSaveMenuLoading] = useState(false);
  const [isSaveChatroomLoading, setIsSaveChatroomLoading] = useState(false);
  const [isSaveSortLoading, setIsSaveSortLoading] = useState(false);
  const [isSaveDisplayLoading, setIsSaveDisplayLoading] = useState(false);
  const [choosedMusic, setChoosedMusic] = useState([]);
  const [isDeleteRoomLoading, setIsDeleteRoomLoading] = useState(false);
  const [isMarkerRemoveLoading, setIsMarkerRemoveLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isMarkerRemoveOpen, onOpen: onMarkerRemoveOpen, onClose: onMarkerRemoveClose } = useDisclosure()
  const { isOpen: isMusicOpen, onOpen: onMusicOpen, onClose: onMusicClose } = useDisclosure()
  const { isOpen: isMarkerOpen, onOpen: onMarkerOpen, onClose: onMarkerClose } = useDisclosure()
  const { isOpen: isMarkerViewOpen, onOpen: onMarkerViewOpen, onClose: onMarkerViewClose } = useDisclosure()
  const [musics, setMusics] = useState("");
  const [images, setImages] = useState("");
  const [currentMusic, setCurrentMusic] = useState(null);
  const [reloadRoom, setReloadRoom] = useState(false);
  const iframe = useRef()
  const [last, setLast] = useState(null)
  const [disable, setDisable] = useState(true)
  const [menus, setMenus] = useState([])
  const [chatrooms, setChatRooms] = useState([])
  const [rooms, setRooms] = useState([])
  const [popups, setPopups] = useState([])
  const [selectedChatroom, setSelectedChatroom] = useState(null)
  const [selectedMenu, setSelectedMenu] = useState(null)
  const [view, setView] = useState(null)
  const [isCreateMarketLoading, SetIsCreateMarkerLoading] = useState(null)
  const [selectMarkerToDelete, setSelectMarkerToDelete] = useState(null)
  const [markerInput, setMarkerInput] = useState({
    "marker-size": "medium",
    "marker-icon": "plus",
    "marker-color": "black",
    "marker-type": 3
  })
  const [markerType, setMarkerType] = useState(3)
  const [isBannerUploading, setIsBannerUploading] = useState(false)
  const [editingMarker, setEditingMarker] = useState(null)
  const { isOpen: isCreatePopupOpen, onOpen: onCreatePopupOpen, onClose: onCreatePopupClose } = useDisclosure()
  const [popupTitle, setPopupTitle] = useState("")
  const [popupType, setPopupType] = useState("content-text")
  const [popupInput, setPopupInput] = useState({})
  const [isCreatePopupLoading, setIsCreatePopupLoading] = useState(false)
  const [popupFiles, setPopupFiles] = useState([])
  const [isImageUploading, setIsImageUploading] = useState(false)
  const [isVideoUploading, setIsVideoUploading] = useState(false)
  const [isSoundUploading, setIsSoundUploading] = useState(false)
  const [videoUploadProgress, setVideoUploadProgress] = useState(0)
  const [soundUploadProgress, setSoundUploadProgress] = useState(0)


  useEffect(() => {
    const id = setInterval(() => {
      if (last && !(disable || (roomData?.image?.day?.status == 0 || roomData?.image?.day?.status == 1 || roomData?.image?.night?.status == 0 || roomData?.image?.night?.status == 1))) {
        if (last?.night?.status != roomData?.image?.night?.status) {
          console.log("night Changed")
          iframe?.current?.contentWindow?.postMessage("reload", "*");

          setTimeout(() => {
            if (iframe)
              iframe?.current?.contentWindow?.postMessage("night-mode", "*");
            else
              location.reload();
          }, 3000)
        }
        if (last?.day?.status != roomData?.image?.day?.status) {
          console.log("day Changed")
          iframe?.current?.contentWindow?.postMessage("reload", "*");
          setTimeout(() => {
            if (iframe)
              iframe?.current?.contentWindow?.postMessage("day-mode", "*");
            else
              location.reload();
          }, 3000)
        }
      }
      setLast(roomData?.image)
      if (roomData?.image?.day?.status == 1 || roomData?.image?.day?.status == 0 || roomData?.image?.night?.status == 1 || roomData?.image?.night?.status == 0) {
        getData()
      }
    }, 10000);
    return () => clearInterval(id);
  }, [roomData, reloadRoom, last]);
  useEffect(() => {
    history.listen(stopMusic);
    getData()
  }, [reloadRoom])
  useEffect(() => {
    const handler = (ev) => {
      if (typeof ev.data !== 'object') return
      if (!ev.data.type) return
      if (ev.data.type !== 'Rotate') return
      if (!ev.data.message) return
      setView({ lat: ev.data.message.lat.follow, lon: ev.data.message.lon.follow })
    }
    window.addEventListener('message', handler)
    // Don't forget to remove addEventListener
    return () => window.removeEventListener('message', handler)
  }, [])
  useEffect(() => {
    allFiles("audio").then((result) => {
      let musics = result.data
      musics.unshift({
        _id: "default",
        filename: "پیش فرض",
        createdAt: "2023-07-30 10:10:10",
        path: "/music/default.mp3",
        size: 4776302,
        name: "پیش فرض"
      })
      setMusics(musics)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [])
  useEffect(() => {
    allFiles("image").then((result) => {
      let images = result.data
      images.unshift({
        path: "",
        filename: ""
      })
      setImages(images)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [])
  useEffect(() => {
    allFiles().then((result) => {
      setPopupFiles(result.data || [])
    }).catch((err) => {
      console.error(err)
    })
  }, [])
  useEffect(() => {
    allChatroom(address).then((result) => {
      let chatrooms = result.data
      chatrooms.unshift({
        _id: "remove",
        title: "ندارد"
      })
      setChatRooms(chatrooms)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [])
  useEffect(() => {
    allRoom(address).then((result) => {
      let rooms = result.data
      rooms.unshift({
        _id: "",
        title: ""
      })
      setRooms(rooms)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [])
  useEffect(() => {
    allPopup(address).then((result) => {
      let popups = result.data.reverse()
      popups.unshift({
        _id: "",
        title: ""
      })
      setPopups(popups)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [])
  useEffect(() => {
    allMenu(address).then((result) => {
      let menus = result.data
      menus.unshift({
        _id: "remove",
        title: "ندارد"
      })
      setMenus(menus)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [])
  function playaction(music) {
    if (currentMusic) {
      currentMusic.new.pause()
    }
    if (!currentMusic || currentMusic._id != music._id) {
      music.new = new Audio(config.host + (music.path.replace("upload/user/", "/assets/users/")))
      music.new.play()
      setCurrentMusic(music)
      setGlobal({
        music
      })
    } else {
      setCurrentMusic(null)
    }
  }
  function stopMusic() {
    let current = getGlobal("music")
    if (current) {
      current.new.pause()
      setGlobal({
        music: null
      })
      setCurrentMusic(null)
    }
  }
  function getData() {
    console.log("call all room")
    allRoom(address, id, { "markers": 0, "image": 0, "radio": 0 }).then((result) => {
      let room = result.data
      console.log(room)
      if (!room) return;
      setTitle(room.title)
      setSort(room.sort)
      setDisplay(room.display)
      room.markers = room.markers.reverse()
      setRoomData(room)
      if (room?.image?.day?.status == 1 || room?.image?.day?.status == 0 || room?.image?.night?.status == 1 || room?.image?.night?.status == 0) {

        toast.info("در حال پردازش فایل‌های پانوراما ...", {
          toastId: "PanoramaInProgress",
          closeButton: false,
          autoClose: false,
          isLoading: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          position: "bottom-right"
        })
      }
      else toast.dismiss("PanoramaInProgress");
      if (room.radio)
        setChoosedMusic([{
          _id: "loaded",
          name: room.radio.filename,
          date: room.radio.date,
          path: room.radio.path
        }])
      else {
        setChoosedMusic([])
      }
      if (room.chat) {
        setSelectedChatroom(room.chat)
      } else setSelectedChatroom(null)
      if (room.menu) {
        setSelectedMenu(room.menu)
      } else setSelectedMenu(null)

    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }
  function Delete() {
    setIsDeleteRoomLoading(true)
    deleteRoom(address, roomData.number).then((result) => {
      history.push("/admin/rooms/" + address)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsDeleteRoomLoading(false)
    })
  }
  function DeleteMarker() {
    setIsMarkerRemoveLoading(true)
    deleteMarker(address, roomData.number, selectMarkerToDelete._id).then((result) => {
      setReloadRoom(!reloadRoom)
      iframe.current.contentWindow.postMessage("reload", "*");
      onMarkerRemoveClose()
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsMarkerRemoveLoading(false)
    })
  }
  function handleIframe() {
    setDisable(false)
  }
  function setRoomMusic(music) {
    if (currentMusic) {
      currentMusic.new.pause()
      setCurrentMusic(null)

    }
    editRoom(address, id, {
      radio: {
        path: music?.path.replace("upload/user/", "/assets/users/"),
        date: music?.createdAt,
        filename: music?.filename,
        size: music?.size
      }
    }).then((result) => {
      setReloadRoom(!reloadRoom)
      iframe.current.contentWindow.postMessage("reload", "*");
      toast.info("جهت پخش موسیقی انتخابی، با نمایش زنده تعامل کنید.", {
        position: "bottom-right"
      })
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }
  function save() {
    setIsSaveLoading(true)
    let data = {
      'title': title
    }
    editRoom(address, id, data).then((result) => {
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setReloadRoom(!reloadRoom)
      setIsSaveLoading(false)
    })
  }
  function saveMenu() {
    setIsSaveMenuLoading(true)
    let data = {
      'menu': selectedMenu
    }
    editRoom(address, id, data).then((result) => {
      setReloadRoom(!reloadRoom)
      iframe.current.contentWindow.postMessage("reload", "*");
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsSaveMenuLoading(false)
    })
  }
  function saveChatroom() {
    setIsSaveChatroomLoading(true)
    let data = {
      'chat': selectedChatroom
    }
    editRoom(address, id, data).then((result) => {
      setReloadRoom(!reloadRoom)
      iframe.current.contentWindow.postMessage("reload", "*");
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsSaveChatroomLoading(false)
    })
  }
  function saveSort() {
    setIsSaveSortLoading(true)
    let data = {
      'sort': sort
    }
    editRoom(address, id, data).then((result) => {
      setReloadRoom(!reloadRoom)
      iframe.current.contentWindow.postMessage("reload", "*");
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsSaveSortLoading(false)
    })
  }
  function saveDisplay() {
    setIsSaveDisplayLoading(true)
    let data = {
      'display': display
    }
    editRoom(address, id, data).then((result) => {
      setReloadRoom(!reloadRoom)
      iframe.current.contentWindow.postMessage("reload", "*");
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsSaveDisplayLoading(false)
    })
  }
  function handlAddMarker() {
    let action = {};
    SetIsCreateMarkerLoading(true)
    let title = markerInput["marker-title"];
    if (!title) {
      toast.error("لطفا عنوان را وارد نمایید.", {
        position: "bottom-right"
      })
      SetIsCreateMarkerLoading(false)
      return
    }
    let size = markerInput["marker-size"];
    let color = markerInput["marker-color"];
    let icon = markerInput["marker-icon"];
    if (markerType == 1) {
      let href = markerInput["marker-href"];
      action = {
        type: "url",
        href
      }
      if (!href) {
        toast.error("لطفا آدرس اینترنتی را وارد نمایید.", {
          position: "bottom-right"
        })
        SetIsCreateMarkerLoading(false)
        return
      }
    } else if (markerType == 2) {
      let id = markerInput["marker-popup"];
      action = {
        type: "popup",
        id: id
      }
      if (!id) {
        toast.error("لطفا پاپ‌آپ مورد نظر را انتخاب کنید.", {
          position: "bottom-right"
        })
        SetIsCreateMarkerLoading(false)
        return
      }
    } else if (markerType == 3) {
      let id = markerInput["marker-room"];
      action = {
        type: "panorama",
        id: id
      }
      if (!id) {
        toast.error("لطفا ایستگاه مورد نظر را انتخاب کنید.", {
          position: "bottom-right"
        })
        SetIsCreateMarkerLoading(false)
        return
      }
    } else if (markerType == 4) {
      let caption = markerInput.caption || markerInput["marker-caption"];
      let image = markerInput["marker-banner-image"]?.replace("upload/user/", "assets/users/");
      action = {
        type: "banner",
        image: {
          href: image,
          caption
        }
      }
      if (!image) {
        toast.error("لطفا تصویر مورد نظر را انتخاب کنید.", {
          position: "bottom-right"
        })
        SetIsCreateMarkerLoading(false)
        return
      }
    }
    const markerData = {
      lat: view.lat,
      lon: view.lon,
      title,
      icon,
      size,
      color,
      action
    };

    if (editingMarker) {
      // ویرایش مارکر
      editMarker(address, roomData.number, editingMarker._id, markerData).then((result) => {
        toast.success("مارکر با موفقیت ویرایش شد.", {
          position: "bottom-right"
        })
        resetMarkerForm()
        onMarkerClose()
        setReloadRoom(!reloadRoom)
        iframe?.current?.contentWindow?.postMessage("reload", "*");
      }).catch((err) => {
        console.error(err)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      }).finally(() => {
        SetIsCreateMarkerLoading(false)
      })
    } else {
      // افزودن مارکر جدید
      addMarker(address, roomData.number, markerData).then((result) => {
        toast.success("با موفقیت انجام شد.", {
          position: "bottom-right"
        })
        resetMarkerForm()
        onMarkerClose()
        setReloadRoom(!reloadRoom)
        iframe?.current?.contentWindow?.postMessage("reload", "*");
      }).catch((err) => {
        console.error(err)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      }).finally(() => {
        SetIsCreateMarkerLoading(false)
      })
    }
  }

  const resetMarkerForm = () => {
    setMarkerType(3)
    setMarkerInput({
      "marker-size": "medium",
      "marker-icon": "plus",
      "marker-color": "black",
      "marker-type": 3
    })
    setEditingMarker(null)
  }

  const openEditMarker = (marker) => {
    setEditingMarker(marker)
    
    // پر کردن فرم با اطلاعات مارکر
    setMarkerInput({
      "marker-title": marker.title || "",
      "marker-size": marker.size || "medium",
      "marker-icon": marker.icon || "plus",
      "marker-color": marker.color || "black",
    })

    // تعیین نوع مارکر
    if (marker.action.type == "url") {
      setMarkerType(1)
      setMarkerInput(prev => ({
        ...prev,
        "marker-href": marker.action.href || ""
      }))
    } else if (marker.action.type == "popup") {
      setMarkerType(2)
      setMarkerInput(prev => ({
        ...prev,
        "marker-popup": marker.action.id || ""
      }))
    } else if (marker.action.type == "panorama") {
      setMarkerType(3)
      setMarkerInput(prev => ({
        ...prev,
        "marker-room": marker.action.id || ""
      }))
    } else if (marker.action.type == "banner") {
      setMarkerType(4)
      setMarkerInput(prev => ({
        ...prev,
        "marker-banner-image": marker.action.image?.href?.replace("assets/users/", "upload/user/") || "",
        "marker-caption": marker.action.image?.caption || ""
      }))
    }

    // باز کردن modal
    onMarkerOpen()
  }
  const handleFormChange = (event) => {
    if (event.target.name == "chatroom")
      setSelectedChatroom(event.target.value)
    else if (event.target.name == "menu")
      setSelectedMenu(event.target.value)
    else if (event.target.name == "sort")
      setSort(event.target.value)
    else if (event.target.name == "display")
      setDisplay(event.target.value)
  }
  const handleMarkerChange = (event, name) => {
    if (event.target) {
      markerInput[event.target.name] = event.target.value
    } else {
      markerInput[name] = event
    }
    setMarkerInput(markerInput)
  }

  const handleBannerUpload = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) return;
    
    const file = acceptedFiles[0];
    setIsBannerUploading(true);
    
    const progressCallback = (percent) => {
      // می‌توانید progress را نمایش دهید
    };

    uploadFile(file, progressCallback)
      .then((result) => {
        // بررسی فرمت‌های مختلف پاسخ API
        const filePath = result?.data?.path || result?.path || result?.data?.file?.path;
        if (filePath) {
          setMarkerInput(prev => ({
            ...prev,
            "marker-banner-image": filePath
          }));
          toast.success("فایل با موفقیت آپلود شد", {
            position: "bottom-right"
          });
        } else {
          console.log("Response format:", result);
          toast.error("خطا در دریافت مسیر فایل", {
            position: "bottom-right"
          });
        }
      })
      .catch((err) => {
        console.error(err);
        if (err?.response?.data?.message?.pr) {
          toast.error(err.response.data.message.pr, {
            position: "bottom-right"
          });
        } else {
          toast.error("خطا در آپلود فایل", {
            position: "bottom-right"
          });
        }
      })
      .finally(() => {
        setIsBannerUploading(false);
      });
  }, []);

  const bannerDropzone = useDropzone({
    onDrop: handleBannerUpload,
    accept: {
      'image/*': ['.jpg', '.jpeg', '.png', '.gif', '.webp']
    },
    maxFiles: 1,
    multiple: false,
    disabled: isBannerUploading
  });

  const handlePopupTypeChange = (event) => {
    setPopupType(event.target.value)
  }

  const handlePopupChanges = (event) => {
    let data = popupInput;
    data[event.target.name] = event.target.value
    setPopupInput({...data})
  }

  const createPopupAction = () => {
    if (popupTitle == "")
      return toast.error("عنوان را وارد کنید.", {
        position: "bottom-right"
      })
    let type = popupType.split("-")[0]
    let data = {}
    if (type == 'content' && popupType.split("-")[1] == "image") {
      data.text = popupInput["image-text"]
      data.link = {
        title: popupInput["image-title"],
        href: popupInput["image-link"],
      }
      data.image = {
        href: popupInput["image-file"]?.replace("upload/user/", "/assets/users/"),
        alt: popupInput["image-alt"]
      }
    } else if (type == 'content' && popupType.split("-")[1] == "video") {
      data.text = popupInput["video-text"]
      data.link = {
        title: popupInput["video-title"],
        href: popupInput["video-link"],
      }
      data.video = popupInput["video-file"]?.replace("upload/user/", "/assets/users/")
    } else if (type == 'content' && popupType.split("-")[1] == "sound") {
      data.text = popupInput["sound-text"]
      data.link = {
        title: popupInput["sound-title"],
        href: popupInput["sound-link"],
      }
      data.audio = popupInput["sound-file"]?.replace("upload/user/", "/assets/users/")
    } else if (type == 'content' && popupType.split("-")[1] == "text") {
      data.text = popupInput["text-text"]
      data.link = {
        title: popupInput["text-title"],
        href: popupInput["text-link"],
      }
    } else if (type == 'iframe') {
      data.href = popupInput["iframe-href"]
      if (!(data.href?.startsWith("http://") || data.href?.startsWith("https://"))) {
        return toast.error("آدرس وارد شده نادرست است، باید با https:// یا http:// شروع شود.", {
          position: "bottom-right"
        })
      }
    } else if (type == 'googleform') {
      data.href = popupInput["googleform-href"]
      if (!(data.href?.startsWith("https://docs.google.com/forms/") || data.href?.startsWith("https://forms.gle/"))) {
        return toast.error("آدرس وارد شده نادرست است، باید با https://docs.google.com/forms/ یا https://forms.gle/ شروع شود.", {
          position: "bottom-right"
        })
      }
    } else if (type == 'list') {
      data.images = (popupInput["list"] || []).map((item) => {
        return {
          href: item.href?.replace("upload/user/", "/assets/users/"),
          caption: item.caption,
          file: item.file,
          target: item.target
        }
      })
    } else if (type == 'gallery') {
      data.images = (popupInput["gallery"] || []).map((item) => {
        return {
          href: item.href?.replace("upload/user/", "/assets/users/"),
          caption: item.caption,
          file: item.file,
        }
      })
    }

    setIsCreatePopupLoading(true)
    createPopup(popupTitle, type, data).then((result) => {
      const newPopup = result.data || result;
      // اضافه کردن پاپ‌آپ جدید به لیست
      setPopups(prev => [newPopup, ...prev]);
      // انتخاب پاپ‌آپ جدید در markerInput
      setMarkerInput(prev => ({
        ...prev,
        "marker-popup": newPopup._id
      }));
      toast.success("پاپ‌آپ با موفقیت ساخته شد و انتخاب شد.", {
        position: "bottom-right"
      })
      onCreatePopupClose()
      // modal افزودن مارکر باید از قبل باز باشد، پس نیازی به باز کردن مجدد نیست
    }).catch((err) => {
      console.error(err)
      if (err?.response?.status == 409)
        return toast.error("آدرس انتخابی تکراری است.", {
          position: "bottom-right"
        })
      else if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsCreatePopupLoading(false)
    })
  }

  const openCreatePopup = () => {
    setPopupTitle("")
    setPopupInput({})
    setPopupType("content-text")
    onCreatePopupOpen()
  }

  const handleImageUpload = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) return;
    
    const file = acceptedFiles[0];
    setIsImageUploading(true);
    
    const progressCallback = (percent) => {
      // می‌توانید progress را نمایش دهید
    };

    uploadFile(file, progressCallback)
      .then((result) => {
        const filePath = result?.data?.path || result?.path || result?.data?.file?.path;
        if (filePath) {
          setPopupInput(prev => ({
            ...prev,
            "image-file": filePath
          }));
          toast.success("فایل تصویر با موفقیت آپلود شد", {
            position: "bottom-right"
          });
        } else {
          console.log("Response format:", result);
          toast.error("خطا در دریافت مسیر فایل", {
            position: "bottom-right"
          });
        }
      })
      .catch((err) => {
        console.error(err);
        if (err?.response?.data?.message?.pr) {
          toast.error(err.response.data.message.pr, {
            position: "bottom-right"
          });
        } else {
          toast.error("خطا در آپلود فایل تصویر", {
            position: "bottom-right"
          });
        }
      })
      .finally(() => {
        setIsImageUploading(false);
      });
  }, []);

  const handleVideoUpload = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) return;
    
    const file = acceptedFiles[0];
    setIsVideoUploading(true);
    setVideoUploadProgress(0);
    
    const progressCallback = (percent) => {
      setVideoUploadProgress(percent);
    };

    uploadFile(file, progressCallback)
      .then((result) => {
        const filePath = result?.data?.path || result?.path || result?.data?.file?.path;
        if (filePath) {
          setPopupInput(prev => ({
            ...prev,
            "video-file": filePath
          }));
          setVideoUploadProgress(100);
          toast.success("فایل ویدیو با موفقیت آپلود شد", {
            position: "bottom-right"
          });
        } else {
          console.log("Response format:", result);
          toast.error("خطا در دریافت مسیر فایل", {
            position: "bottom-right"
          });
        }
      })
      .catch((err) => {
        console.error(err);
        if (err?.response?.data?.message?.pr) {
          toast.error(err.response.data.message.pr, {
            position: "bottom-right"
          });
        } else {
          toast.error("خطا در آپلود فایل ویدیو", {
            position: "bottom-right"
          });
        }
      })
      .finally(() => {
        setIsVideoUploading(false);
        setTimeout(() => setVideoUploadProgress(0), 1000);
      });
  }, []);

  const handleSoundUpload = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) return;
    
    const file = acceptedFiles[0];
    setIsSoundUploading(true);
    setSoundUploadProgress(0);
    
    const progressCallback = (percent) => {
      setSoundUploadProgress(percent);
    };

    uploadFile(file, progressCallback)
      .then((result) => {
        const filePath = result?.data?.path || result?.path || result?.data?.file?.path;
        if (filePath) {
          setPopupInput(prev => ({
            ...prev,
            "sound-file": filePath
          }));
          setSoundUploadProgress(100);
          toast.success("فایل صدا با موفقیت آپلود شد", {
            position: "bottom-right"
          });
        } else {
          console.log("Response format:", result);
          toast.error("خطا در دریافت مسیر فایل", {
            position: "bottom-right"
          });
        }
      })
      .catch((err) => {
        console.error(err);
        if (err?.response?.data?.message?.pr) {
          toast.error(err.response.data.message.pr, {
            position: "bottom-right"
          });
        } else {
          toast.error("خطا در آپلود فایل صدا", {
            position: "bottom-right"
          });
        }
      })
      .finally(() => {
        setIsSoundUploading(false);
        setTimeout(() => setSoundUploadProgress(0), 1000);
      });
  }, []);

  const imageDropzone = useDropzone({
    onDrop: handleImageUpload,
    accept: {
      'image/*': ['.jpg', '.jpeg', '.png', '.gif', '.webp']
    },
    maxFiles: 1,
    multiple: false,
    disabled: isImageUploading
  });

  const videoDropzone = useDropzone({
    onDrop: handleVideoUpload,
    accept: {
      'video/*': ['.mp4', '.webm', '.ogg']
    },
    maxFiles: 1,
    multiple: false,
    disabled: isVideoUploading
  });

  const soundDropzone = useDropzone({
    onDrop: handleSoundUpload,
    accept: {
      'audio/*': ['.mp3', '.wav', '.ogg', '.m4a']
    },
    maxFiles: 1,
    multiple: false,
    disabled: isSoundUploading
  });

  return (
    <Flex direction='column' pt={{ base: "120px", md: "75px" }}>
      <Grid templateColumns={{ sm: "1fr", lg: "1.2fr 2fr" }} templateRows='1fr'>
        <Box>
          <Card p='16px' mb='24px'>
            <CardHeader>
              <Flex
                direction={{ sm: "column", md: "row" }}
                justify='space-between'
                align='center'
                minHeight='60px'
                w='100%'>
                <Box>
                  <Stat>
                    <StatNumber>
                      <Text fontSize='md' color={textColor} fontWeight='bold'>
                        <IconButton
                          _hover={{ color: "tomato" }}
                          color={textColor}
                          onClick={onOpen}
                          variant="no-effects"
                          aria-label="حذف ایستگاه"
                          size="lg"
                          icon={<RiDeleteBin3Fill />}
                        />
                        ایستگاه {roomData.title}
                      </Text>
                    </StatNumber>
                    <StatHelpText>
                      <Link mr={"50px"} textAlign={"right"} w={"100%"} fontSize={"xs"} href={'/admin/rooms/' + address} >
                        ایستگاه‌ها <ExternalLinkIcon mx='2px' />
                      </Link>
                    </StatHelpText>
                  </Stat>
                </Box>
                <Box mt={{ sm: "30px", md: "0px" }}>
                  <Button fontSize='xs' mr="4" onClick={() => {
                    window.open(config.host + "/tour/" + address + "/" + roomData.number, '_blank', 'noopener,noreferrer');
                  }} >مشاهده ایستگاه</Button>
                </Box>
              </Flex>
              <Flex mt="24px" mr="12px"
                direction={{ sm: "column", md: "row" }}
              >
                <FormControl w='100%' id="tour-title">
                  <FormLabel fontSize="sm" >عنوان ایستگاه</FormLabel>
                  <Input fontSize="xs" placeholder={roomData.title} value={title} onChange={e => setTitle(e.target.value)} />
                </FormControl>
              </Flex>
              <Flex>
                <Spacer />
                <Box pt="20px" w={{ sm: "100%", md: "auto" }} >
                  <ButtonGroup w="100%" textAlign="left">
                    <NiceButton
                      color={colorMode === "dark" ? "white" : "black"}
                      isLoading={isSaveLoading}
                      onClick={save}
                      fontSize='xs'
                      w='100%'
                    >
                      ذخیره
                    </NiceButton>
                  </ButtonGroup>
                </Box>

              </Flex>
            </CardHeader>
            <CardBody>
            </CardBody>
          </Card>
          <Card mb={"24px"} p='25px' >
            <CardHeader>
              <Box textAlign={"center"}>
                <Upload setDisable={setDisable} reload={getData} iframe={iframe.current} disabled={disable || (roomData?.image?.day?.status == 0 || roomData?.image?.day?.status == 1 || roomData?.image?.night?.status == 0 || roomData?.image?.night?.status == 1)} type="day" w={{ sm: "100%", md: "30%" }} fontSize='xs' address={address} id={id} bg={colorMode === "dark" ? "blue.400" : "blue.300"} leftIcon={<BiSun />} title={roomData?.image?.day?.status == 1 ? "در حال پردازش" : roomData?.image?.day?.status == 0 ? "فایل جدید" : "آپلود نمای روز"} />
                <Upload mt={{ sm: "10px", md: "0" }} setDisable={setDisable} reload={getData} iframe={iframe.current} disabled={disable || (roomData?.image?.day?.status == 0 || roomData?.image?.day?.status == 1 || roomData?.image?.night?.status == 0 || roomData?.image?.night?.status == 1)} type="night" w={{ sm: "100%", md: "30%" }} fontSize='xs' address={address} id={id} bg={colorMode === "dark" ? "blue.700" : "blue.200"} mr={{ sm: "0", md: "4" }} leftIcon={<BiMoon />} title={roomData?.image?.night?.status == 1 ? "در حال پردازش" : roomData?.image?.night?.status == 0 ? "فایل جدید" : "آپلود نمای شب"} />
                <Upload mt={{ sm: "10px", md: "0" }} mr={{ sm: "0", md: "4" }} setDisable={setDisable} reload={getData} iframe={iframe.current} disabled={disable} type="logo" w={{ sm: "100%", md: "30%" }} fontSize='xs' address={address} id={id} bg={colorMode === "dark" ? "blue.900" : "blue.100"} leftIcon={<BiCategoryAlt />} title={"آپلود لوگو"} />
              </Box>
            </CardHeader>
            <CardBody>
            </CardBody>
          </Card>
          <Card minHeight={{ sm: "default", lg: "320px" }} p='16px' >
            <CardHeader>
              <Flex
                direction={{ sm: "column", md: "row" }}
                justify='space-between'
                align='center'
                minHeight='60px'
                w='100%'>
                <Text fontSize='md' color={textColor} fontWeight='bold'>
                  لیست مارکرها
                </Text>
              </Flex>
              <Flex>
                <Flex minH={{ sm: "0px", lg: "145px" }} mt="10px" direction='column' w='100%' mr="10px">
                  {roomData && roomData?.markers?.map((row, idx) => {
                    if (idx > 2) return;
                    return (
                      <MarkerRow
                        title={row.title ? row.title : "بدون متن"}
                        type={row.action.type}
                        size={row.size}
                        color={row.color}
                        icon={row.icon}
                        key={idx}
                        action={
                          <Flex gap="10px">
                            <Button onClick={() => openEditMarker(row)} variant="no-effects" color={"blue.400"} fontSize="xs" >
                              ویرایش
                            </Button>
                            <Button onClick={() => { setSelectMarkerToDelete(row); onMarkerRemoveOpen() }} variant="no-effects" color={"red.400"} fontSize="xs" >
                              حذف
                            </Button>
                          </Flex>
                        }
                      />
                    );
                  })}
                </Flex>
              </Flex>
              <Flex direction='column'>
                <ButtonGroup w="100%">
                  <NiceButton
                    onClick={onMarkerViewOpen}
                    color={colorMode === "dark" ? "white" : "black"}
                    fontSize='xs'
                    w='100%'
                  >
                    مشاهده همه
                  </NiceButton>
                </ButtonGroup>
              </Flex>
            </CardHeader>
            <CardBody>
            </CardBody>
          </Card>
        </Box>
        <Card
          p='22px'
          my={{ sm: "24px", lg: "0px" }}
          ms={{ sm: "0px", lg: "24px" }}>
          <CardHeader>
          </CardHeader>
          <CardBody>
            <Flex
              mt={"10px"}
              direction='column' w='100%'>
              <iframe hidden={!roomData} ref={iframe} height={"550px"} allowFullScreen={true} onLoad={handleIframe} src={config.host + "/tour-content?name=" + address + "&lat=0&lon=0&fav=0&id=" + roomData.number + "&cross=show"}></iframe>
            </Flex>
            <Flex mt={"20px"}>
              <FormControl w='100%' >
                <Button
                  fontSize={"xs"}
                  color={colorMode === "dark" && "white"}
                  _hover={colorMode === "dark" && "none"}
                  borderColor={colorMode === "dark" && "white"}
                  onClick={() => { resetMarkerForm(); onMarkerOpen(); }}
                  w={"100%"}
                  minW='110px'
                  maxH='35px'>
                  افزودن مارکر
                </Button>
                <FormHelperText textAlign={"center"} mt={"20px"} fontSize={"xs"}>علامت + را روی محل مد نظر خود قرار داده و روی دکمه افزودن مارکر کلیک کنید.</FormHelperText>
              </FormControl>
            </Flex>
          </CardBody>
        </Card>
      </Grid>




      <Grid templateColumns={{ sm: "1fr", lg: "2fr 1fr" }}>
        <Grid templateColumns={{
          sm: "1fr",
          md: "1fr 1fr",
          xl: "1fr 1fr",
        }}
          templateRows={{ sm: "auto auto auto", md: "1fr auto", xl: "1fr 1fr" }}
          gap='12px'>
          <Card style={{ height: "max-content" }} mt={{ lg: "24px" }} mb={"0px"}>
            <Flex direction='column'>
              <CardBody>
                <Flex direction='column' w='100%'>
                  <Grid
                    mt="20px"
                    templateColumns={{
                      sm: "1fr",
                      md: "1fr",
                      xl: "1fr",
                    }}
                    templateRows={{ sm: "auto auto auto", md: "2fr auto", xl: "2fr" }}>
                    <Flex direction='column' align='center' w='100%' py='14px'>
                      <IconBox as='box' h={"60px"} w={"60px"} bg={iconBgColor}>
                        <Icon h={"24px"} w={"24px"} color={iconBlue} as={RiChat1Fill} />
                      </IconBox>
                      <Flex
                        direction='column'
                        m='14px'
                        justify='center'
                        textAlign='center'
                        align='center'
                        w='100%'>
                        <Text fontSize='sm' color={textColor}>
                          چت‌روم و پشتیبانی
                        </Text>
                        <Text
                          mt="10px"
                          fontSize='xs'
                          color='gray.400'>
                          چت‌روم در پایین صفحه سمت راست نمایش داده می‌شود.
                        </Text>
                      </Flex>

                      <Select textAlign={"center"} w="150px" dir={"ltr"} fontSize="xs" name="chatroom"
                        onChange={event => handleFormChange(event)}
                      >
                        {chatrooms && chatrooms.map((item, idx) => {
                          return (
                            <option selected={item._id == roomData.chat} dir={"rtl"} value={item._id}>{item.title}</option>
                          );
                        })}
                      </Select>
                      <HSeparator mt={"24px"} mb={"12px"} />
                      <Box>
                        <Button p="0px" m="0px" onClick={() => { history.push("/admin/chatrooms/" + address + "/") }} fontSize='xs' variant="no-effects" leftIcon={<RiArrowRightSLine />}>مدیریت</Button>
                      </Box>
                      <Box mt="22px" w={"100%"} textAlign={"left"} >
                        <ButtonGroup>
                          <NiceButton
                            color={colorMode === "dark" ? "white" : "black"}
                            isLoading={isSaveChatroomLoading}
                            onClick={saveChatroom}
                            fontSize='xs'
                          >
                            ذخیره
                          </NiceButton>
                        </ButtonGroup>
                      </Box>
                    </Flex>
                  </Grid>
                </Flex>
              </CardBody>
            </Flex>
          </Card>
          <Card style={{ height: "max-content" }} mt={{ lg: "24px" }} mb={"0px"}>
            <Flex direction='column'>
              <CardBody>
                <Flex direction='column' w='100%'>
                  <Grid
                    mt="20px"
                    templateColumns={{
                      sm: "1fr",
                      md: "1fr",
                      xl: "1fr",
                    }}
                    templateRows={{ sm: "auto auto auto", md: "2fr auto", xl: "2fr" }}
                    gap='0px'>
                    <Flex direction='column' align='center' w='100%' py='14px'>
                      <IconBox as='box' h={"60px"} w={"60px"} bg={iconBgColor}>
                        <Icon h={"24px"} w={"24px"} color={iconBlue} as={RiMenuLine} />
                      </IconBox>
                      <Flex
                        direction='column'
                        m='14px'
                        justify='center'
                        textAlign='center'
                        align='center'
                        w='100%'>
                        <Text fontSize='sm' color={textColor}>
                          انتخاب منو
                        </Text>
                        <Text
                          mt="10px"
                          fontSize='xs'
                          color='gray.400'>
                          منو در بالای صفحه سمت راست نمایش داده می‌شود.
                        </Text>
                      </Flex>
                      <Select textAlign={"center"} w="150px" dir={"ltr"} fontSize="xs" name="menu"
                        onChange={event => handleFormChange(event)}>
                        {menus && menus.map((item, idx) => {
                          return (
                            <option selected={item._id == roomData.menu} dir={"rtl"} value={item._id}>{item.title}</option>
                          );
                        })}
                      </Select>
                      <HSeparator mt={"24px"} mb={"12px"} />
                      <Box>
                        <Button p="0px" m="0px" onClick={() => { history.push("/admin/menus/" + address + "/") }} fontSize='xs' variant="no-effects" leftIcon={<RiArrowRightSLine />}>مدیریت</Button>
                      </Box>
                      <Box mt="22px" w={"100%"} textAlign={"left"} >
                        <ButtonGroup>
                          <NiceButton
                            color={colorMode === "dark" ? "white" : "black"}
                            isLoading={isSaveMenuLoading}
                            onClick={saveMenu}
                            fontSize='xs'>
                            ذخیره
                          </NiceButton>
                        </ButtonGroup>
                      </Box>

                    </Flex>
                  </Grid>
                </Flex>
              </CardBody>
            </Flex>
          </Card>
          <Card style={{ height: "max-content" }}>
            <Flex direction='column'>
              <CardBody>
                <Flex direction='column' w='100%'>
                  <Grid
                    mt="20px"
                    templateColumns={{
                      sm: "1fr",
                      md: "1fr",
                      xl: "1fr",
                    }}
                    templateRows={{ sm: "auto auto auto", md: "2fr auto", xl: "2fr" }}>
                    <Flex direction='column' align='center' w='100%' py='14px'>
                      <IconBox as='box' h={"60px"} w={"60px"} bg={iconBgColor}>
                        <Icon h={"24px"} w={"24px"} color={iconBlue} as={RiSlideshow4Line} />
                      </IconBox>
                      <Flex
                        direction='column'
                        m='14px'
                        justify='center'
                        textAlign='center'
                        align='center'
                        w='100%'>
                        <Text fontSize='sm' color={textColor}>
                          نوع نمایش

                        </Text>
                        <Text
                          mt="10px"
                          fontSize='xs'
                          color='gray.400'>
                          می‌توانید نوع نمایش ایستگاه را کنترل کنید.
                        </Text>
                      </Flex>

                      <Select textAlign={"center"} w="150px" dir={"ltr"} fontSize="xs" name="display"
                        onChange={event => handleFormChange(event)}>
                        <option selected={display == 0} dir={"rtl"} value={0}>نمایش در دسترسی سریع</option>
                        <option selected={display == 1} dir={"rtl"} value={1}>عدم نمایش در دسترسی سریع</option>
                        <option selected={display == 2} dir={"rtl"} value={2}>پیش نویس</option>
                      </Select>
                      <Box mt="22px" w={"100%"} textAlign={"left"} >
                        <ButtonGroup>
                          <NiceButton
                            color={colorMode === "dark" ? "white" : "black"}
                            isLoading={isSaveDisplayLoading}
                            onClick={saveDisplay}
                            fontSize='xs'
                          >
                            ذخیره
                          </NiceButton>
                        </ButtonGroup>
                      </Box>
                    </Flex>
                  </Grid>
                </Flex>
              </CardBody>
            </Flex>
          </Card>
          <Card style={{ height: "max-content" }}>
            <Flex direction='column'>
              <CardBody>
                <Flex direction='column' w='100%'>
                  <Grid
                    mt="20px"
                    templateColumns={{
                      sm: "1fr",
                      md: "1fr",
                      xl: "1fr",
                    }}
                    templateRows={{ sm: "auto auto auto", md: "2fr auto", xl: "2fr" }}>
                    <Flex direction='column' align='center' w='100%' py='14px'>
                      <IconBox as='box' h={"60px"} w={"60px"} bg={iconBgColor}>
                        <Icon h={"24px"} w={"24px"} color={iconBlue} as={RiStackLine} />
                      </IconBox>
                      <Flex
                        direction='column'
                        m='14px'
                        justify='center'
                        textAlign='center'
                        align='center'
                        w='100%'>
                        <Text fontSize='sm' color={textColor}>
                          اولویت
                        </Text>
                        <Text
                          mt="10px"
                          fontSize='xs'
                          color='gray.400'>
                          عدد بزرگتر در دسترسی سریع بالاتر قرار می‌گیرند.
                        </Text>
                      </Flex>

                      <FormControl textAlign={"center"} w="150px" dir={"ltr"} fontSize="xs" name="sort-input">
                        <Input textAlign={"center"} name="sort" type="number" fontSize="xs" placeholder={roomData.sort} value={sort} onChange={e => setSort(e.target.value)} />
                      </FormControl>
                      <Box mt="22px" w={"100%"} textAlign={"left"} >
                        <ButtonGroup>
                          <NiceButton
                            color={colorMode === "dark" ? "white" : "black"}
                            isLoading={isSaveSortLoading}
                            onClick={saveSort}
                            fontSize='xs'
                          >
                            ذخیره
                          </NiceButton>
                        </ButtonGroup>
                      </Box>
                    </Flex>
                  </Grid>
                </Flex>
              </CardBody>
            </Flex>
          </Card>
        </Grid>
        <Grid>
          <Card my='24px' ms={{ lg: "24px" }} style={{ height: "max-content" }}>
            <CardHeader mb='12px'>
              <Flex direction='column' w='100%'>
                <Flex
                  direction={{ sm: "column", lg: "row" }}
                  justify={{ sm: "center", lg: "space-between" }}
                  w='100%'
                  my={{ md: "12px" }}>
                  <Text
                    color={textColor}
                    fontSize='md'
                    fontWeight='bold'>
                    موسیقی ایستگاه
                  </Text>
                </Flex>
              </Flex>
            </CardHeader>
            <CardBody>
              <Flex mt="10px" direction='column' w='100%'>
                <Text
                  color='gray.400'
                  fontSize="xs"
                  mt="20px"
                  my='12px'>
                  انتخاب شده
                </Text>
                {choosedMusic.map((row, idx) => {
                  return (
                    <MusicRow
                      color="green.500"
                      name={row.name}
                      logo={currentMusic?._id == row._id ? RiPauseMiniLine : RiPlayFill}
                      playaction={() => playaction(row)}
                      date={moment(row.createdAt).format('jYYYY-jM-jD HH:mm:ss')}
                      price={row.price}
                      key={idx}
                      action={<Button onClick={() => setRoomMusic(null)} variant="no-effects" color={"red.400"} fontSize="xs" >
                        حذف
                      </Button>}
                    />
                  );
                })}
                <HSeparator mt="30px" mb="30px" />
                <Text
                  color='gray.400'
                  fontSize="xs"
                  mt="20px"
                  my='12px'>
                  انتخاب از فایل های موسیقی آپلود شده
                </Text>
                {musics && musics.slice(0, 5).map((row, idx) => {
                  return (
                    <MusicRow
                      name={row.filename}
                      logo={currentMusic?._id == row._id ? RiPauseMiniLine : RiPlayFill}
                      playaction={() => playaction(row)}
                      address={config.host + (row.path.replace("upload/user/", "/assets/users/"))}
                      date={moment(row.createdAt).format('jYYYY-jM-jD HH:mm:ss')}
                      key={idx}
                      action={<Button onClick={() => setRoomMusic(row)} variant="no-effects" color={"gray.400"} fontSize="xs" >
                        انتخاب
                      </Button>}
                    />
                  );
                })}
                <Grid>
                  <Button onClick={onMusicOpen} fontSize="xs">مشاهده همه</Button>
                </Grid>
              </Flex>
            </CardBody>
          </Card>
        </Grid>
      </Grid>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontSize="md">حذف ایستگاه</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
            حذف ایستگاه باعث خواهد شد همه اطلاعات و تنظیمات آن به صورت بی بازگشت حذف شود. مطمئنید؟
          </ModalBody>
          <ModalFooter>
            <Button fontSize='xs' onClick={onClose}>خیر</Button>
            <NiceButton mr="10px"
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isDeleteRoomLoading}
              onClick={Delete}
              fontSize='xs'
              w="100px"
            >
              بله
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        isOpen={isMarkerRemoveOpen}
        onClose={onMarkerRemoveClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontSize="md">حذف مارکر</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
            آیا مطمئنید که میخواهید این مارکر را حذف کنید؟
          </ModalBody>
          <ModalFooter>
            <Button fontSize='xs' onClick={onMarkerRemoveClose}>خیر</Button>
            <NiceButton mr="10px"
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isMarkerRemoveLoading}
              onClick={DeleteMarker}
              fontSize='xs'
              w="100px"
            >
              بله
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isMusicOpen} onClose={() => { onMusicClose(), stopMusic() }}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"md"} textAlign="center" >نمایش همه فایل‌های موسیقی</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Scrollbars dir="ltr" autoHeightMin={0}
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              hideTracksWhenNotNeeded={true}
              autoHeight
              autoHeightMax={490} >
              <Grid dir="rtl" pr="20px">
                {musics && musics.map((row, idx) => {
                  return (
                    <MusicRow
                      name={row.filename}
                      logo={currentMusic?._id == row._id ? RiPauseMiniLine : RiPlayFill}
                      playaction={() => playaction(row)}
                      address={config.host + (row.path.replace("upload/user/", "/assets/users/"))}
                      date={moment(row.createdAt).format('jYYYY-jM-jD HH:mm:ss')}
                      key={idx}
                      action={<Button onClick={() => setRoomMusic(row)} variant="no-effects" color={"gray.400"} fontSize="xs" >
                        انتخاب
                      </Button>}
                    />
                  );
                })}
              </Grid>
            </Scrollbars>
          </ModalBody>
          <ModalFooter>
            <NiceButton
              onClick={() => {
                onMusicClose();
                stopMusic();
                history.push("/admin/files?tab=3");
              }}
              variant="no-effects"
              colorScheme="blue"
              fontSize="sm"
            >
              رفتن به صفحه فایل‌ها (بخش صوت)
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isMarkerViewOpen} onClose={onMarkerViewClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"md"} textAlign="center" >نمایش همه مارکرها</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Scrollbars dir="ltr" autoHeightMin={0}
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              hideTracksWhenNotNeeded={true}
              autoHeight
              autoHeightMax={490} >
              <Grid dir="rtl" pr="20px">
                {roomData && roomData?.markers?.map((row, idx) => {
                  return (
                    <MarkerRow
                      title={row.title ? row.title : "بدون متن"}
                      type={row.action.type}
                      size={row.size}
                      color={row.color}
                      icon={row.icon}
                      key={idx}
                      action={
                        <Flex gap="10px">
                          <Button onClick={() => openEditMarker(row)} variant="no-effects" color={"blue.400"} fontSize="xs" >
                            ویرایش
                          </Button>
                          <Button onClick={() => { setSelectMarkerToDelete(row); onMarkerRemoveOpen() }} variant="no-effects" color={"red.400"} fontSize="xs" >
                            حذف
                          </Button>
                        </Flex>
                      }
                    />
                  );
                })}
              </Grid>
            </Scrollbars>
          </ModalBody>
          <ModalFooter>

          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isMarkerOpen} onClose={() => { onMarkerClose(); resetMarkerForm(); }}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"md"} textAlign="center" >{editingMarker ? "ویرایش مارکر" : "افزودن مارکر"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Scrollbars dir="ltr" autoHeightMin={0}
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              hideTracksWhenNotNeeded={true}
              autoHeight
              autoHeightMax={490} >
              <Grid mb={"20px"} dir="rtl" pr="20px">
                <FormControl w='100%' ml="5" id="marker-title-input">
                  <FormLabel fontSize="xs" >عنوان</FormLabel>
                  <Input name="marker-title" fontSize="xs" placeholder={"عنوان را وارد نمایید."} value={markerInput["marker-title"]} onChange={e => handleMarkerChange(e.target.value, "marker-title")} />
                </FormControl>
                <Flex>
                  <FormControl w='100%' ml="5" mt={"20px"} id="tour-title">
                    <FormLabel fontSize="xs" >نوع</FormLabel>
                    <Select w={"100%"} textAlign={"center"} dir={"ltr"} fontSize="xs" name="marker-type"
                      onChange={event => setMarkerType(event.target.value)}>
                      <option selected={markerType == 1} dir={"rtl"} value={1}>آدرس اینترنتی</option>
                      <option selected={markerType == 2} dir={"rtl"} value={2}>پاپ آپ</option>
                      <option selected={markerType == 3} dir={"rtl"} value={3}>ایستگاه</option>
                      <option selected={markerType == 4} dir={"rtl"} value={4}>بنر</option>
                    </Select>
                  </FormControl>
                  <FormControl w='100%' mt={"20px"} id="marker-icon-input">
                    <FormLabel fontSize="xs" >آیکون</FormLabel>
                    <Select w={"100%"} textAlign={"center"} dir={"ltr"} fontSize="xs" name="marker-icon"
                      onChange={event => handleMarkerChange(event)}>
                      {icon.map((row, idx) => {
                        return (
                          <option selected={markerInput["marker-icon"] == row.value} dir={"rtl"} value={row.value}>{row.title}</option>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Flex>
                <Flex>
                  <FormControl ml="5" mt={"20px"} id="marker-color-input">
                    <FormLabel fontSize="xs" >رنگ</FormLabel>
                    <Select w={"100%"} textAlign={"center"} dir={"ltr"} fontSize="xs" name="marker-color"
                      onChange={event => handleMarkerChange(event)}>
                      {color.map((row, idx) => {
                        return (
                          <option selected={markerInput["marker-color"] == row.value} dir={"rtl"} value={row.value}>{row.title}</option>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl mt={"20px"} id="marker-color-input">
                    <FormLabel fontSize="xs" >اندازه</FormLabel>
                    <Select w={"100%"} textAlign={"center"} dir={"ltr"} fontSize="xs" name="marker-size"
                      onChange={event => handleMarkerChange(event)}>
                      <option selected={markerInput["marker-size"] == "small"} dir={"rtl"} value={"small"}>کوچک</option>
                      <option selected={markerInput["marker-size"] == "medium"} dir={"rtl"} value={"medium"}>متوسط</option>
                      <option selected={markerInput["marker-size"] == "large"} dir={"rtl"} value={"large"}>بزرگ</option>
                    </Select>
                  </FormControl>
                </Flex>
                <Grid hidden={markerType != 1}>
                  <FormControl w='100%' mt={"20px"} id="marker-href-input">
                    <FormLabel fontSize="xs" >آدرس اینترنتی</FormLabel>
                    <Input dir="ltr" name='marker-href' fontSize="xs" placeholder={"https://domain.ir"} value={markerInput.href} onChange={e => handleMarkerChange(e.target.value, "marker-href")} />
                  </FormControl>
                </Grid>
                <Grid hidden={markerType != 2}>
                  <FormControl mt={"20px"} id="marker-popup-input">
                    <FormLabel fontSize="xs" >پاپ‌آپ</FormLabel>
                    <Flex gap="10px">
                      <Select flex="1" textAlign={"center"} dir={"ltr"} fontSize="xs" name="marker-popup"
                        onChange={event => handleMarkerChange(event)}>
                        <option value="">انتخاب کنید</option>
                        {popups && popups.map((row, idx) => {
                          return (
                            <option selected={markerInput["marker-popup"] == row._id} dir={"rtl"} value={row._id}>{row.title}</option>
                          );
                        })}
                      </Select>
                      <NiceButton
                        onClick={openCreatePopup}
                        fontSize='xs'
                        variant='outline'
                        w="120px">
                        ساخت جدید
                      </NiceButton>
                    </Flex>
                    <FormHelperText fontSize={"xs"}>پاپ‌آپ را انتخاب کنید یا یک پاپ‌آپ جدید بسازید</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid hidden={markerType != 3}>
                  <FormControl mt={"20px"} id="marker-room-input">
                    <FormLabel fontSize="xs" >ایستگاه</FormLabel>
                    <Select w={"100%"} textAlign={"center"} dir={"ltr"} fontSize="xs" name="marker-room"
                      onChange={event => handleMarkerChange(event)}>
                      {rooms && rooms.map((row, idx) => {
                        return (
                          <option selected={markerInput["marker-room"] == row.number} dir={"rtl"} value={row.number}>{row.title}</option>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid hidden={markerType != 4}>
                  <FormControl mt={"20px"} id="marker-banner-image-input">
                    <FormLabel fontSize="xs" >تصویر</FormLabel>
                    <Box
                      {...bannerDropzone.getRootProps()}
                      border="2px dashed"
                      borderColor={bannerDropzone.isDragActive ? "blue.400" : "gray.300"}
                      borderRadius="md"
                      p="20px"
                      textAlign="center"
                      cursor={isBannerUploading ? "not-allowed" : "pointer"}
                      bg={bannerDropzone.isDragActive ? "blue.50" : "transparent"}
                      opacity={isBannerUploading ? 0.6 : 1}
                      transition="all 0.2s"
                      _hover={!isBannerUploading ? { borderColor: "blue.400", bg: "blue.50" } : {}}
                    >
                      <input {...bannerDropzone.getInputProps()} />
                      {isBannerUploading ? (
                        <Text fontSize="xs" color="blue.500">
                          در حال آپلود...
                        </Text>
                      ) : markerInput["marker-banner-image"] ? (
                        <Text fontSize="xs" color="green.500">
                          فایل انتخاب شده: {markerInput["marker-banner-image"].split('/').pop()}
                        </Text>
                      ) : (
                        <Text fontSize="xs" color="gray.500">
                          {bannerDropzone.isDragActive
                            ? "فایل را اینجا رها کنید"
                            : "فایل را اینجا بکشید یا کلیک کنید"}
                        </Text>
                      )}
                    </Box>
                    <FormHelperText fontSize={"xs"}>فایل تصویری را انتخاب یا آپلود کنید</FormHelperText>
                  </FormControl>
                  <FormControl w='100%' mt={"20px"} id="marker-caption-input">
                    <FormLabel fontSize="xs" >کپشن تصویر</FormLabel>
                    <Input name='marker-caption' fontSize="xs" placeholder={"متن مورد نظر را وارد کنید."} value={markerInput["marker-caption"] || markerInput.caption || ""} onChange={e => handleMarkerChange(e.target.value, "marker-caption")} />
                  </FormControl>
                </Grid>
              </Grid>
            </Scrollbars>
          </ModalBody>
          <ModalFooter>
            <NiceButton
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isCreateMarketLoading}
              onClick={handlAddMarker}
              fontSize='xs'
              w="100px">
              ثبت
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isCreatePopupOpen} onClose={onCreatePopupClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"md"} textAlign="center" >ساخت پاپ آپ جدید</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Scrollbars dir="ltr" autoHeightMin={0}
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              hideTracksWhenNotNeeded={true}
              autoHeight
              autoHeightMax={490}
            >
              <Grid dir="rtl" mr={"20px"} ml={"10px"} mb="10px">
                <FormControl mt={"20px"} id="popup-title">
                  <FormLabel fontSize={"xs"} >عنوان (فارسی)</FormLabel>
                  <Input fontSize={"xs"} value={popupTitle} onChange={e => setPopupTitle(e.target.value)} type="text" />
                </FormControl>
                <FormControl w='100%' mt={"20px"} id="popup-type-input">
                  <FormLabel fontSize={"xs"}  >نوع</FormLabel>
                  <Select w={"100%"} textAlign={"right"} dir={"ltr"} fontSize="xs" name="popup-type"
                    onChange={event => handlePopupTypeChange(event)}>
                    <option selected={popupType == "gallery"} dir={"rtl"} value="gallery">گالری تصاویر</option>
                    <option selected={popupType == "list"} dir={"rtl"} value="list">لیست</option>
                    <option selected={popupType == "iframe"} dir={"rtl"} value="iframe">قالب خطی (آی فریم)</option>
                    <option selected={popupType == "googleform"} dir={"rtl"} value="googleform">گوگل فرم</option>
                    <option selected={popupType == "content-sound"} dir={"rtl"} value="content-sound">صدا</option>
                    <option selected={popupType == "content-image"} dir={"rtl"} value="content-image">تصویر</option>
                    <option selected={popupType == "content-video"} dir={"rtl"} value="content-video">ویدیو</option>
                    <option selected={popupType == "content-text"} dir={"rtl"} value="content-text">متن</option>
                  </Select>
                </FormControl>
                <Grid hidden={popupType != "gallery"}>
                  <PopupGallery files={popupFiles} popups={popups} popupInput={popupInput} setPopupInput={setPopupInput} />
                </Grid>
                <Grid hidden={popupType != "list"}>
                  <PopupList files={popupFiles} popups={popups} popupInput={popupInput} setPopupInput={setPopupInput} />
                </Grid>
                <Grid hidden={popupType != "googleform"}>
                  <FormControl mt={"20px"} id="googleform">
                    <FormLabel fontSize={"xs"} >لینک</FormLabel>
                    <Input fontSize={"xs"} placeholder="https://docs.google.com/forms/" dir="ltr" name="googleform-href" value={popupInput["googleform-href"]} onChange={event => handlePopupChanges(event)} type="text" />
                  </FormControl>
                </Grid>
                <Grid hidden={popupType != "iframe"}>
                  <FormControl mt={"20px"} id="iframe">
                    <FormLabel fontSize={"xs"} >لینک</FormLabel>
                    <Input fontSize={"xs"} placeholder="https://tpan.ir" dir="ltr" name="iframe-href" value={popupInput["iframe-href"]} onChange={event => handlePopupChanges(event)} type="text" />
                  </FormControl>
                </Grid>
                <Grid hidden={popupType.split("-")[1] != "video"}>
                  <FormControl mt={"20px"} id="video-text">
                    <FormLabel fontSize={"xs"} >متن</FormLabel>
                    <Textarea fontSize={"xs"} name="video-text" onChange={event => handlePopupChanges(event)} type="text" h="auto" autoGrow={10} rows={5} height="auto" value={popupInput["video-text"]} placeholder={""} />
                  </FormControl>
                  <FormControl w='100%' mt={"20px"} id="video-files-input">
                    <FormLabel fontSize={"xs"} >فایل ویدیو</FormLabel>
                    <Box
                      {...videoDropzone.getRootProps()}
                      border="2px dashed"
                      borderColor={videoDropzone.isDragActive ? "blue.400" : "gray.300"}
                      borderRadius="md"
                      p="20px"
                      textAlign="center"
                      cursor={isVideoUploading ? "not-allowed" : "pointer"}
                      bg={videoDropzone.isDragActive ? "blue.50" : "transparent"}
                      opacity={isVideoUploading ? 0.6 : 1}
                      transition="all 0.2s"
                      _hover={!isVideoUploading ? { borderColor: "blue.400", bg: "blue.50" } : {}}
                    >
                      <input {...videoDropzone.getInputProps()} />
                      {isVideoUploading ? (
                        <Flex direction="column" align="center" gap="10px">
                          <Text fontSize="xs" color="blue.500">
                            در حال آپلود... {videoUploadProgress}%
                          </Text>
                          <Progress 
                            value={videoUploadProgress} 
                            colorScheme="blue" 
                            size="sm" 
                            width="100%" 
                            borderRadius="md"
                          />
                        </Flex>
                      ) : popupInput["video-file"] ? (
                        <Text fontSize="xs" color="green.500">
                          فایل انتخاب شده: {popupInput["video-file"].split('/').pop()}
                        </Text>
                      ) : (
                        <Text fontSize="xs" color="gray.500">
                          {videoDropzone.isDragActive
                            ? "فایل را اینجا رها کنید"
                            : "فایل ویدیو را اینجا بکشید یا کلیک کنید"}
                        </Text>
                      )}
                    </Box>
                    <FormHelperText fontSize={"xs"}>فایل ویدیو را انتخاب یا آپلود کنید (mp4, webm, ogg)</FormHelperText>
                  </FormControl>
                  <FormControl mt={"20px"} id="video-title">
                    <FormLabel fontSize={"xs"} >عنوان دکمه (اختیاری)</FormLabel>
                    <Input fontSize={"xs"} name="video-title" value={popupInput["video-title"]} onChange={event => handlePopupChanges(event)} type="text" />
                  </FormControl>
                  <FormControl mt={"20px"} id="video-link">
                    <FormLabel fontSize={"xs"} >لینک دکمه (اختیاری)</FormLabel>
                    <Input fontSize={"xs"} dir="ltr" name="video-link" value={popupInput["video-link"]} onChange={event => handlePopupChanges(event)} type="text" />
                  </FormControl>
                </Grid>
                <Grid hidden={popupType.split("-")[1] != "sound"}>
                  <FormControl mt={"20px"} id="sound-text">
                    <FormLabel fontSize={"xs"} >متن</FormLabel>
                    <Textarea fontSize={"xs"} name="sound-text" onChange={event => handlePopupChanges(event)} type="text" h="auto" autoGrow={10} rows={5} height="auto" value={popupInput["sound-text"]} placeholder={""} />
                  </FormControl>
                  <FormControl w='100%' mt={"20px"} id="sound-files-input">
                    <FormLabel fontSize={"xs"} >فایل صدا</FormLabel>
                    <Box
                      {...soundDropzone.getRootProps()}
                      border="2px dashed"
                      borderColor={soundDropzone.isDragActive ? "blue.400" : "gray.300"}
                      borderRadius="md"
                      p="20px"
                      textAlign="center"
                      cursor={isSoundUploading ? "not-allowed" : "pointer"}
                      bg={soundDropzone.isDragActive ? "blue.50" : "transparent"}
                      opacity={isSoundUploading ? 0.6 : 1}
                      transition="all 0.2s"
                      _hover={!isSoundUploading ? { borderColor: "blue.400", bg: "blue.50" } : {}}
                    >
                      <input {...soundDropzone.getInputProps()} />
                      {isSoundUploading ? (
                        <Flex direction="column" align="center" gap="10px">
                          <Text fontSize="xs" color="blue.500">
                            در حال آپلود... {soundUploadProgress}%
                          </Text>
                          <Progress 
                            value={soundUploadProgress} 
                            colorScheme="blue" 
                            size="sm" 
                            width="100%" 
                            borderRadius="md"
                          />
                        </Flex>
                      ) : popupInput["sound-file"] ? (
                        <Text fontSize="xs" color="green.500">
                          فایل انتخاب شده: {popupInput["sound-file"].split('/').pop()}
                        </Text>
                      ) : (
                        <Text fontSize="xs" color="gray.500">
                          {soundDropzone.isDragActive
                            ? "فایل را اینجا رها کنید"
                            : "فایل صدا را اینجا بکشید یا کلیک کنید"}
                        </Text>
                      )}
                    </Box>
                    <FormHelperText fontSize={"xs"}>فایل صدا را انتخاب یا آپلود کنید (mp3, wav, ogg, m4a)</FormHelperText>
                  </FormControl>
                  <FormControl mt={"20px"} id="sound-title">
                    <FormLabel fontSize={"xs"} >عنوان دکمه (اختیاری)</FormLabel>
                    <Input fontSize={"xs"} name="sound-title" value={popupInput["sound-title"]} onChange={event => handlePopupChanges(event)} type="text" />
                  </FormControl>
                  <FormControl mt={"20px"} id="sound-link">
                    <FormLabel fontSize={"xs"} >لینک دکمه (اختیاری)</FormLabel>
                    <Input fontSize={"xs"} dir="ltr" name="sound-link" value={popupInput["sound-link"]} onChange={event => handlePopupChanges(event)} type="text" />
                  </FormControl>
                </Grid>
                <Grid hidden={popupType.split("-")[1] != "text"}>
                  <FormControl mt={"20px"} id="text-text">
                    <FormLabel fontSize={"xs"} >متن</FormLabel>
                    <Textarea fontSize={"xs"} name="text-text" onChange={event => handlePopupChanges(event)} type="text" h="auto" autoGrow={10} rows={5} height="auto" value={popupInput["text-text"]} placeholder={""} />
                  </FormControl>
                  <FormControl mt={"20px"} id="text-title">
                    <FormLabel fontSize={"xs"} >عنوان دکمه (اختیاری)</FormLabel>
                    <Input fontSize={"xs"} name="text-title" value={popupInput["text-title"]} onChange={event => handlePopupChanges(event)} type="text" />
                  </FormControl>
                  <FormControl mt={"20px"} id="text-link">
                    <FormLabel fontSize={"xs"} >لینک دکمه (اختیاری)</FormLabel>
                    <Input fontSize={"xs"} dir="ltr" name="text-link" value={popupInput["text-link"]} onChange={event => handlePopupChanges(event)} type="text" />
                  </FormControl>
                </Grid>
                <Grid hidden={popupType.split("-")[1] != "image"}>
                  <FormControl mt={"20px"} id="image-text">
                    <FormLabel fontSize={"xs"} >متن</FormLabel>
                    <Textarea fontSize={"xs"} name="image-text" onChange={event => handlePopupChanges(event)} type="text" h="auto" autoGrow={10} rows={5} height="auto" value={popupInput["image-text"]} placeholder={""} />
                  </FormControl>
                  <FormControl w='100%' mt={"20px"} id="image-files-input">
                    <FormLabel fontSize={"xs"} >فایل تصویر</FormLabel>
                    <Box
                      {...imageDropzone.getRootProps()}
                      border="2px dashed"
                      borderColor={imageDropzone.isDragActive ? "blue.400" : "gray.300"}
                      borderRadius="md"
                      p="20px"
                      textAlign="center"
                      cursor={isImageUploading ? "not-allowed" : "pointer"}
                      bg={imageDropzone.isDragActive ? "blue.50" : "transparent"}
                      opacity={isImageUploading ? 0.6 : 1}
                      transition="all 0.2s"
                      _hover={!isImageUploading ? { borderColor: "blue.400", bg: "blue.50" } : {}}
                    >
                      <input {...imageDropzone.getInputProps()} />
                      {isImageUploading ? (
                        <Text fontSize="xs" color="blue.500">
                          در حال آپلود...
                        </Text>
                      ) : popupInput["image-file"] ? (
                        <Text fontSize="xs" color="green.500">
                          فایل انتخاب شده: {popupInput["image-file"].split('/').pop()}
                        </Text>
                      ) : (
                        <Text fontSize="xs" color="gray.500">
                          {imageDropzone.isDragActive
                            ? "فایل را اینجا رها کنید"
                            : "فایل تصویر را اینجا بکشید یا کلیک کنید"}
                        </Text>
                      )}
                    </Box>
                    <FormHelperText fontSize={"xs"}>فایل تصویر را انتخاب یا آپلود کنید (jpg, jpeg, png, gif, webp)</FormHelperText>
                  </FormControl>
                  <FormControl mt={"20px"} id="image-alt">
                    <FormLabel fontSize={"xs"} >توضیحات تصویر</FormLabel>
                    <Input fontSize={"xs"} name="image-alt" value={popupInput["image-alt"]} onChange={event => handlePopupChanges(event)} type="text" />
                  </FormControl>
                  <FormControl mt={"20px"} id="image-title">
                    <FormLabel fontSize={"xs"} >عنوان دکمه (اختیاری)</FormLabel>
                    <Input fontSize={"xs"} name="image-title" value={popupInput["image-title"]} onChange={event => handlePopupChanges(event)} type="text" />
                  </FormControl>
                  <FormControl mt={"20px"} id="image-link">
                    <FormLabel fontSize={"xs"} >لینک دکمه (اختیاری)</FormLabel>
                    <Input fontSize={"xs"} dir="ltr" name="image-link" value={popupInput["image-link"]} onChange={event => handlePopupChanges(event)} type="text" />
                  </FormControl>
                </Grid>
              </Grid>
            </Scrollbars>
          </ModalBody>
          <ModalFooter>
            <NiceButton
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isCreatePopupLoading}
              onClick={createPopupAction}
              fontSize='xs'
              w="100px"
            >
              ثبت
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default RoomDetails;
